export default __webpack_public_path__ + "static/media/hh-character-regular-positive-speaking.ac187e45.mp4";